<script lang='ts'>
import { onDestroy } from 'svelte';
import { pevent } from '../analytics';
import AssetViewer from './AssetViewer.svelte';
import HeaderBox from './HeaderBox.svelte';

interface Asset {
  title: string;
  url: string;
  type: 'pdf';
  image: string;
}

interface OpenOn {
  time: string;
  text: string;
}

export let sectionTitle;
export let title = '';
export let openOn: OpenOn;
export let assets: Asset[] = [];
export let subtitle;
export let header;

let open = false;
let viewAsset;
let openTimer;

function evalOpen() {
  clearTimeout(openTimer);

  if (!openOn) {
    open = true;
    return;
  }

  const openTime = new Date(openOn.time).getTime();
  const now = Date.now();
  if (openTime <= now) {
    open = true;
    return;
  }

  openTimer = setTimeout(() => open = true, openTime - now);
}

onDestroy(() => clearTimeout(openTimer))

function show(asset) {
  pevent('asset', 'view', asset.url, 1);
  
  if (asset.type === 'video' || asset.type === 'image' || asset.type === 'vimeo') {
    viewAsset = asset;
    return;
  }

  window.open(asset.url, "_blank");
}

function iconName(type) {
  if (type === 'vimeo') return 'video';
  return type;
}

$: openOn, evalOpen();
</script>

<div class="section-header">{sectionTitle}</div>

<HeaderBox {title} {subtitle} style={header} />

{#if open}
  <div class="asset-container row">
    {#each assets as asset}
      <div class='asset col vcenter hcenter' on:click={() => show(asset)} style="background-image: url({asset.image})">
        <!-- {asset.title} -->
        <div class="bar row vcenter">
          <div class="icon">
            <!-- svelte-ignore a11y-missing-attribute -->
            <img src="/img/type-{iconName(asset.type)}.svg" />
          </div>
          <div class="flex-1">{asset.title}</div>
        </div>
      </div>
    {/each}
  </div>
{:else}
  <div>
    {openOn.text}
  </div>
{/if}

{#if viewAsset}
  <div class="modal" on:click={() => viewAsset = undefined}>
    <div class="modal-container">
      <AssetViewer asset={viewAsset} />
    </div>
  </div>
{/if}

<style lang="scss">
@import '../util';

.asset-container {
  flex-wrap: wrap;
}

.modal-container {
  background-color: white;
  border-radius: 5px;
  color: black;
  padding: 6px;
  min-width: 320px;
  min-height: 185px;

  @include tablet {
    padding: 0;
    background-color: unset;
    border-radius: unset;
  }
}

.asset {
  @include shadow;
  position: relative;
  width: 320px;
  height: 185px;
  background-color: white;
  // border-radius: 5px;
  color: white;
  margin: 8px;
  padding: 16px;
  cursor: pointer;
  background-size: cover;
  overflow: hidden;
  transition: ease-out 150ms;
  
  &:hover {
    transform: scale(1.05);
  }
}

.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
  padding: 4px;
  font-size: 20px;
}

.highlight {
  color: var(--guardsmen-red);
}

.icon {
  background-color: white;
  border-radius: 8px;
  margin-right: 5px;
  pointer-events: none;

  width: 28px;
  height: 28px;
}
</style>